/// <reference path="../../../app.definition.ts" />

// typescript namespace
import angular from "angular";
export class PhotoCropController {

    static $inject = ["$uibModalInstance", "photoPath", "$rootScope"];

    constructor(
        private $uibModalInstance: angular.ui.bootstrap.IModalServiceInstance,
        photoPath,
        $rootScope
    ) {
        var photoCropVm: any = this;
        $rootScope.mainShowLoader = false;
        photoCropVm.croppedImage = '';
        //console.log(photoPath,'pp');
        photoCropVm.photoPath = photoPath;

        photoCropVm.setPhoto = () => {
            //console.log( photoCropVm.croppedImage);
        }

        photoCropVm.close = () => $uibModalInstance.close({
            "croppedImage": photoCropVm.croppedImage
        });

        photoCropVm.closeWithOutSave = () => $uibModalInstance.close();




    }
}


angular.module('eCareVault.common.popUp')
    .controller('PhotoCropController', PhotoCropController);
